"use strict";

/* Using a self-executing anonymous function - (function(){})(); - so that all variables and functions defined within
 aren’t available to the outside world - we just expose gtmCustom...

 We construct if not existing a new GTMCustom object - this will collect all the data we need for GTM
 The GTMCustom object contains arrays that we then use - the same as we did before when the vars were up top.
 As the gtmCustom object is only initiated within the deferred JavaScript - we do not need to worry about timing of HTML items on the page
 We do need to be mindful of AJAX requests, however - taken care of by the connectedCallback method in the ProductObject class.

 Need to make compatible with Safari 12
 */

(function () {
    try {
        class GtmCustom {
            setPageList(page, list, ecomm_pagetype) {
                this.pageType = page;
                this.list_name = list;
                this.ecomm_pagetype = ecomm_pagetype;
            }

            constructor(templateName, currency, subtotal) {
                this.templateName = "default";
                this.productArray = [];
                this.impressions = [];
                this.multiArray = [];
                this.isReceipt = false;
                this.recIndex = 0;
                this.subtotal = subtotal;
                this.shop_currency = "default";
                this.ecomm_pagetype = "other";
                this.currentProduct = "";
                this.templateName = templateName;
                this.shop_currency = currency;
                if (this.templateName.indexOf("cart") > -1) {
                    this.setPageList("CART", "Cart Recs", "cart");
                } else if (this.templateName.indexOf("collection") > -1) {
                    this.setPageList("PLP", "Native Collection Page", "category");
                } else if (this.templateName.indexOf("search") > -1) {
                    this.setPageList("SEARCH", "Native Search Results", "searchresults");
                } else if (this.templateName.indexOf("index") > -1) {
                    this.setPageList("HOME", "Home Page Recs", "home");
                } else if (this.templateName.indexOf("product") > -1) {
                    this.setPageList("PDP", "PDP Recs", "product");
                }
            }
        }

        let init = function () {
            let el = document.querySelector('#dataLayerInit');
            // Instantiate our tracking object - currently using a single instance per page - but could be per event / widget
            let gtmCustom = new GtmCustom(el.dataset.template, el.dataset.currency, el.dataset.subtotal);

            // Set up our custom HTML objects with their relevant listeners for initialise and clicks
            // Click handlers setup within here....
            defineCustomElements(gtmCustom);

            // Gather any product impressions - submit them using the array defined in the custom elements (data.pageviw = AJAX - Non Interact Event)
            // Do not look for PDP Recs here - they are handled by separate listener
            if (gtmCustom.pageType === "HOME" || gtmCustom.pageType === "PLP" || gtmCustom.pageType === "SEARCH" || gtmCustom.pageType === "CART") {
                trackProductListImpressions(gtmCustom, "data.pageView", 0);
            }

            if (gtmCustom.pageType === "CART") {
                trackViewCart(gtmCustom);
            }

            /** bind a handler for PLP AJAX  **/
            document.body.addEventListener('paginated', function (e) {
                console.log("Pagination v2 fired - pushing products from array position: ", e.detail);
                trackProductListImpressions(gtmCustom, "data.pageView", e.detail);
            });
            console.log("Current gtmCustom obj - pushing dataLayer.complete", gtmCustom);
            dataLayer.push({
                'event': 'dataLayer.complete', 'ecomm_pagetype': gtmCustom.ecomm_pagetype
            });
            // Quick view available all over - so generic handler
            //quickViewPDPInit();
            //miniCartPageInit();
        };

        let defineCustomElements = function (gtmCustom) {
            // Used every time a render item object is printed to page - fires JS events to push data objects into gtmCustom properties / arrays.
            class ProductObject extends HTMLElement {
                constructor() {
                    super();
                }

                /* Used for when a user clicks on a PLP card */
                setupClickHandler(anchorTags, key) {
                    for (let i = 0; i < anchorTags.length; i++) {
                        // Set this for observation help (not actually needed)
                        anchorTags[i].setAttribute("data-key", key);
                        // Bind click handler
                        anchorTags[i].addEventListener('click', event => {
                            //event.preventDefault();
                            console.log("Click happened from ProductObject derived click handler; " + key + ": ", event.target);
                            trackPLPClick(gtmCustom, key);
                        });
                    }
                }

                /* Used for when a user clicks on remove from bag - need qty - dependant upon DOM structure of */
                setupClickHandlerRemoveFromCarts(anchorTag, key, source) {
                    // Set this for observation help (not actually needed)
                    anchorTag.setAttribute("data-key", key);
                    let qty = anchorTag.parentElement.querySelector("quantity-input input").value;
                    // Bind click handler
                    anchorTag.addEventListener('click', event => {
                        //event.preventDefault();
                        console.log("Click happened from MiniCart click handler; " + key + ", qty:  " + qty + ": ", event.target);
                        trackRemoveFromCart(gtmCustom, key, qty, source);
                    });
                }

                connectedCallback() {
                    let jsonProduct = this.dataset.json;
                    let objProduct = JSON.parse(jsonProduct);
                    let key = this.id;
                    let scope = this.dataset.scope;
                    // Handle case when single product is on PDP - or a quick view on PLP
                    if (scope === "PDP") {
                        gtmCustom.currentProduct = objProduct;
                        trackProductImpression(gtmCustom, gtmCustom.currentProduct);
                        // Bind click handler for add to bag here - as we also then capture quick add to bag.
                        //console.log("Binding click handler", this.parentElement);
                        productAddToBagHandler(this.parentElement, gtmCustom);
                    } else if (scope === "CARD") {
                        // Handle case when we are on PLP / search / home page - seeing recs / cart etc.
                        objProduct = JSON.parse(jsonProduct, function (key, value) {
                            if (key === "list") return gtmCustom.list_name;
                            if (key === "position") return gtmCustom.recIndex;
                            return value; // return everything else unchanged
                        });

                        gtmCustom.recIndex++;
                        gtmCustom.impressions.push(objProduct);
                        let anchorTags = this.parentElement.querySelectorAll("a");
                        this.setupClickHandler(anchorTags, key);
                    } else if (scope === "MINICART") {
                        let anchorTag = this.parentElement; // cart remove button
                        this.setupClickHandlerRemoveFromCarts(anchorTag, key, "MINICART");
                    } else if (scope === "CART") {
                        let anchorTag = this.parentElement.parentElement.querySelector("cart-remove-button"); // cart remove button
                        this.setupClickHandlerRemoveFromCarts(anchorTag, key, "CART");
                    }
                    // Always run the addition to our generic product array - keeps all data we need for cart removal etc.
                    objProduct.scope = scope;
                    gtmCustom.productArray[key] = objProduct;
                    if (!gtmCustom.multiArray[scope]) gtmCustom.multiArray[scope] = [];
                    gtmCustom.multiArray[scope].push(objProduct);
                    //console.log("Current product: ", window.gtmCustom.currentProduct);
                    console.log("Connected callback - on product-object: " + this.dataset.scope + ", " + objProduct.id + ", " + objProduct.variant);
                }
            }

            customElements.define('product-object', ProductObject);

            class ArrayConclusion extends HTMLElement {
                constructor() {
                    super();
                }

                connectedCallback() {
                    console.log("Array Conclusion rendered - callback: ", this.dataset.scope);
                    trackProductListImpressions(gtmCustom, "data.pageView", 0);
                }
            }

            customElements.define('array-conclusion', ArrayConclusion);
        };

        /** Define all of the dataLayer push events (Init) **/

            // Gathers the products within the impressions array - and pushes to datalayer with list name
        let trackProductListImpressions = function (gtmCustom, eventName, startIndex) {
                // Handle recs on the HomePage, PDP,  all PLP  & Search (pageView is AJAX - non interactive)
                let relevantArray = gtmCustom.impressions.slice(startIndex);
                console.log("Track product List impressions - dataLayer push: " + eventName + ", startIndex: " + startIndex + "; ", relevantArray);
                clearDataLayer();
                dataLayer.push({
                    'event': eventName,
                    'eventCategory': 'Ecommerce',
                    'eventAction': 'Impressions - ' + gtmCustom.list_name,
                    'ecommerce': {
                        'currencyCode': gtmCustom.shop_currency, // Local currency is optional.
                        'impressions': relevantArray
                    }
                });
            };

        let trackViewCart = function (gtmCustom) {
            let relevantArray = gtmCustom.multiArray['CART'];
            console.log("Track view cart - dataLayer push; ", relevantArray, gtmCustom);
            clearDataLayer();
            dataLayer.push({
                'event': "view_cart",
                ecommerce: {
                    'currency': gtmCustom.shop_currency, // Local currency is optional.
                    'value': gtmCustom.subtotal,
                    'items': relevantArray
                }
            });
        };

        let clearDataLayer = function () {
            dataLayer.push({
                ecommerce: null
            }); // Clear the previous ecommerce object.
        }

        // Used for PDP views - to prevent wrong bounce numbers - non interact
        let trackProductImpression = function (gtmCustom, prodObj) {

            clearDataLayer();
            let label = "PDP Impression";
            //console.log("gtmCustom:", gtmCustom);
            // We're using a PDP object - but on a PLP page - must be quick view add to cart
            if (gtmCustom.pageType === "PLP") {
                label = "Quick View Impression"
            }
            console.log("Track trackProductImpression  - dataLayer push, label: " + label + ", prodObj: " + prodObj.variant);
            dataLayer.push({
                'event': 'data.pageView',
                'eventCategory': 'Ecommerce (non interact - overrideen)',
                'eventAction': 'Product Impression',
                'eventLabel': label,
                'ecommerce': {
                    'currencyCode': gtmCustom.shop_currency, 'detail': {
                        'products': [prodObj]
                    }
                }
            });
        };

        // This method now needed all over site due to quick view & home page Add to Bag form
        let trackAddToCart = function (gtmCustom, prodObj, intQuantity) {

            clearDataLayer();
            let label = "PDP Add to cart";
            // We're using a PDP object - but on a PLP page - must be quick view add to cart
            if (gtmCustom.pageType === "PLP") {
                label = "Quick View Add to cart"
            }
            console.log("Track trackAddToCart  - dataLayer push: " + prodObj.variant + ", label:" + label);
            dataLayer.push({
                'event': 'gaEvent', 'eventCategory': 'Ecommerce', 'eventAction': 'Add to Cart', 'eventLabel': label,
                'ecommerce': {
                    'currencyCode': gtmCustom.shop_currency, 'add': {
                        'products': [getCurrentProductQuantity(prodObj, intQuantity)]
                    }
                }
            });
        };

        // Adds quantity parameter to the product object
        let getCurrentProductQuantity = function (prodObj, intQuantity) {
            prodObj["quantity"] = intQuantity;
            return prodObj;
        };

        // Product List click - needed from home page, PDP and PLP
        let trackPLPClick = function (gtmCustom, productArrayID) {
            console.log("PLP click - push: ", gtmCustom.productArray[productArrayID]);
            clearDataLayer();
            dataLayer.push({
                'event': 'gaEvent', 'eventCategory': 'Ecommerce', 'eventAction': 'Product Click', 'ecommerce': {
                    'click': {
                        'actionField': {
                            'list': gtmCustom.list_name
                        }, // Optional list property.
                        'products': [gtmCustom.productArray[productArrayID]]
                    }
                }
            });
        };

        /** Bind event of add to bag being pressed - on quick view or PDP **/
        let productAddToBagHandler = function (domelement, gtmCustom) {
            //console.log("PDP event handlers init", gtmCustom);
            let addButton = domelement.querySelector('[name="add"]');
            let qtyInput = domelement.querySelector('[name="quantity"]');
            let qtyInputValue = (qtyInput ? qtyInput.value : 1);
            // If the event handler already bound - do not do again....
            if (addButton.dataset.clickinit) {
                return;
            }
            addButton.addEventListener('click', event => {
                //console.log("Click happened from add button; " + addButton + ": " + qtyInput + ", ", event.target);
                //console.log("PDP click: ", gtmCustom);
                trackAddToCart(gtmCustom, gtmCustom.currentProduct, qtyInputValue);
            });
            addButton.setAttribute("data-clickinit", true);
        };

        // Used on both mini cart and full cart
        let trackRemoveFromCart = function (gtmCustom, productArrayID, qty, source) {
            let product = gtmCustom.productArray[productArrayID];
            product["quantity"] = qty;
            let valueLine = product["quantity"] * product["price"];
            console.log("full cart removal: " + productArrayID + ", " + qty + ", value:" + valueLine + ", product: ", product);
            clearDataLayer();
            dataLayer.push({
                'event': 'gaEvent', 'eventCategory': 'Ecommerce', 'eventAction': 'Remove from Cart',
                'label': "Remove via: " + source,
                'ecommerce': {
                    'value': valueLine,
                    'remove': {
                        'products': [product]
                    }
                }
            });
        };

        // All function declared - initialise.....
        init();
    } catch (err) {
        console.log(err);
    }
})();